const langI18n = {
  vie: {
    // Step 1
    text_1: 'Kiểm tra thẻ hỗ trợ Trả góp',
    text_2: 'Tính năng',
    text_3: 'KHÔNG dùng để thanh toán',
    text_4: 'mà',
    text_5: 'chỉ để kiểm tra',
    text_6: 'điều kiện trả góp của thẻ, giúp chủ thẻ không cần phải đến cửa hàng của ĐVCNT.',
    
    text_7_: '',
    text_7: ' số đầu của thẻ',
    text_7__: '8',

    text_8: 'Ngày hết hạn',
    text_9: 'Số tiền đơn hàng',
    text_10: 'Kiểm tra',
    // Step 2
    text_11: 'Thẻ đủ điều kiện trả góp',
    text_12: '(Chỉ áp dụng tại thời điểm kiểm tra, nếu KH giao dịch Trả góp sau 1-2 ngày thì cần kiểm tra lại.)',
    text_13: 'Số tiền đơn hàng',
    text_14: 'Chọn kỳ trả góp',
    text_15: 'Tháng',
    text_16: 'Trả góp mỗi tháng',
    text_17: 'Hình thức thanh toán',
    text_18: 'Quẹt tại quầy',
    text_19: 'Online qua link',
    text_20: 'Phí dịch vụ',
    text_21: 'Phí chuyển đổi TG',
    text_22: 'Tổng tiền thanh toán',
    text_23: 'Hoàn tất',
    text_24: 'Chọn thẻ khác',
    text_25: 'Đóng',
    text_26: 'Tiếp tục',
    text_27: 'Thẻ không đủ điều kiện Trả góp!',
    text_28: 'Thẻ của bạn không được ngân hàng hỗ trợ Trả góp. Vui lòng chọn thẻ khác hoặc Thanh toán trả thẳng (không Trả góp).',
    text_29: '* Thẻ không hỗ trợ',
    text_30: '* Sai định dạng',
    text_31: 'Đang tải dữ liệu...',
    text_32: '* Hết hạn',
    text_33: '* Nhập số tiền >= 3000.000',
    text_34: 'Quay lại',
    text_35: 'Chỉnh sửa',
    text_36: 'Cập nhật',
    text_37: 'Chọn ngân hàng trả góp',
    text_38: 'Chọn ngân hàng',
    text_39: 'Hoặc',
    text_40: 'Kiểm tra mà Không có thông tin thẻ của Khách hàng.',
    text_41: 'Ngân hàng hỗ trợ trả góp',
    text_42: 'Chọn loại thẻ',
    text_43: 'Để thực hiện giao dịch Trả góp, hãy quay lại chọn tính năng',
    text_44: 'Quẹt thẻ',
    text_45: 'hoặc',
    text_46: 'tạo link.',
    text_47: '',
    text_48: 'hoặc không có thông tin thẻ',
    text_49: 'Chọn ngân hàng khác'
  },
  eng: {
    // Step 1
    text_1: 'Check the installment card',
    text_2: 'The feature is',
    text_3: 'NOT used for payment',
    text_4: 'but',
    text_5: 'only to check',
    text_6: 'the card`s installment eligibility, helping the cardholder avoid having to visit the merchant`s store.',
    
    text_7_: 'First ',
    text_7: ' card digits',
    text_7__: '8',

    text_8: 'Exp. date',
    text_9: 'Order amount',
    text_10: 'Check',
    // Step 2
    text_11: 'The installment payment eligible card',
    text_12: '(Only applicable at the time of checking; if the customer opts for installment payment after 1-2 days, a reevaluation is necessary.)',
    text_13: 'Order amount',
    text_14: 'Choose the installment period',
    text_15: 'Months',
    text_16: 'Monthly installment',
    text_17: 'Payment method',
    text_18: 'Swipe counter',
    text_19: 'Online via link',
    text_20: 'Service fee',
    text_21: 'Conversion fee',
    text_22: 'Payment amount',
    text_23: 'Complete',
    text_24: 'Check another card',
    text_25: 'Close',
    text_26: 'Continue',
    text_27: 'Card not eligible for installments!',
    text_28: 'Card not supported for installment payment. Choose another card or pay in full (no installment).',
    text_29: '* Unsupported card',
    text_30: '* Wrong format',
    text_31: 'Loading...',
    text_32: '* Expired',
    text_33: '* The amount is >= 3.000.000',
    text_34: 'Back',
    text_35: 'Edit',
    text_36: 'Update',
    text_37: 'Choose installment bank',
    text_38: 'Choose bank',
    text_39: 'Or',
    text_40: 'Check without Customer`s Card Information.',
    text_41: 'Installment bank',
    text_42: 'Select payment card type',
    text_43: 'To proceed with the Installment transaction, please go back and select the',
    text_44: 'Swipe Card',
    text_45: 'or',
    text_46: 'Create Installment Link',
    text_47: 'feature.',
    text_48: 'or no information card',
    text_49: 'Choose bank other'
  }
}

export default langI18n
